<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-2">
        <div class="row">
          <div class="col-md-12 ts-space-y-2">
            <label class="required">{{ $t('village.provinceNameEn') }}</label>
            <a-select
              v-model="model.province_code"
              :options="provinces"
              showSearch
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              class="ts-w-full"
              :placeholder="$t('village.provinceNameEn')"
              @change="onProvinceChange"
            ></a-select>
            <div class="tw-text-red-600" v-if="errors.has('province_code')">
              {{ errors.first('province_code') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-space-y-2">
            <label class="required">{{ $t('village.districtNameEn') }}</label>
            <a-select
              v-model="model.district_code"
              :options="districts"
              showSearch
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              class="ts-w-full"
              :placeholder="$t('village.districtNameEn')"
              @change="onDistrictChange"
            ></a-select>
            <div class="tw-text-red-600" v-if="errors.has('district_code')">
              {{ errors.first('district_code') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-space-y-2">
            <label class="required">{{ $t('village.communeNameEn') }}</label>
            <a-select
              v-model="model.commune_code"
              :options="communes"
              showSearch
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              class="ts-w-full"
              :placeholder="$t('commune.communeNameEn')"
            ></a-select>
            <div class="tw-text-red-600" v-if="errors.has('commune_code')">
              {{ errors.first('commune_code') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-space-y-2">
            <label class="required">{{ $t('commune.nameKh') }}</label>
            <input
              type="text"
              v-model.trim="model.name_kh"
              class="form-control"
              :placeholder="$t('commune.nameKh')"
            />
            <div class="tw-text-red-600" v-if="errors.has('name_kh')">
              {{ errors.first('name_kh') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-space-y-2">
            <label class="required">{{ $t('commune.nameEn') }}</label>
            <input
              type="text"
              v-model.trim="model.name_en"
              class="form-control"
              :placeholder="$t('commune.nameEn')"
            />
            <div class="tw-text-red-600" v-if="errors.has('name_en')">
              {{ errors.first('name_en') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-mt-3 text-right">
            <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button
              v-if="!isUpdate"
              color="primary"
              @click.prevent="onSave"
              >{{ $t('save') }}</ts-button
            >
            <ts-button
              v-if="isUpdate"
              color="primary"
              @click.prevent="onSave"
              >{{ $t('update') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import { join, isEmpty } from 'lodash'

export default {
  name: 'districtForm',
  props: ['record'],
  data() {
    return {
      loading: false,
      errors: new Errors(),
      districts: [],
      provinces: [],
      communes: [],
      model: {
        province_code: null,
        district_code: null,
        commune_code: null,
        name_en: null,
        name_kh: null
      }
    }
  },
  created() {
    this.setData()
    this.fetchDistrict()
  },
  computed: {
    isUpdate() {
      return !isEmpty(this.record)
    }
  },
  methods: {
    ...mapActions('corporate/address', ['getFormViewData', 'village']),
    fetchDistrict() {
      this.loading = true
      this.formView(['districts', 'provinces', 'communes'], {
        provinceCode: this.model.province_code,
        districtCode: this.model.district_code
      }).finally(() => (this.loading = false))
    },
    onProvinceChange() {
      this.loading = true
      this.formView(['districts'], {
        provinceCode: this.model.province_code
      }).finally(() => (this.loading = false))
    },
    onDistrictChange() {
      this.loading = true
      this.formView(['communes'], {
        districtCode: this.model.district_code
      }).finally(() => (this.loading = false))
    },
    async formView(fnName, queries = {}) {
      let response = await this.getFormViewData({
        params: Object.assign(
          {},
          {
            fnName: join(fnName, ',')
          },
          queries
        )
      })

      fnName.forEach(fn => {
        this[fn] = response.data[fn].map(el => ({
          value: el.code,
          label: el.name_en
        }))
      })
    },
    setData() {
      if (this.record) {
        this.loading = true
        this.model.province_code = this.record.province_code
        this.model.district_code = this.record.district_code
        this.model.commune_code = this.record.commune_code
        this.model.village_code = this.record.village_code
        this.model.name_en = this.record.name_en
        this.model.name_kh = this.record.name_kh
      }
    },
    onSave() {
      this.loading = true
      this.village(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
